import { createSelector } from 'reselect';
import {
  selectTravelCart,
  selectAirTotal,
  selectAirTotalCloud,
  selectRailTotal,
  selectHotelTotal,
  selectCarTotal,
} from './trip.selector';
import { selectChangeRes, selectTripResults } from './search.selector';
import { selectTotalSeatPrice } from './seat.selector';
import { PassengerTypeEnum } from '../../constants/PassengerTypes';

export const selectTotalCartAmount = createSelector(
  selectTravelCart,
  selectTotalSeatPrice,
  selectAirTotal,
  selectAirTotalCloud,
  selectRailTotal,
  selectHotelTotal,
  selectCarTotal,
  selectChangeRes,
  selectTripResults,
  (
    travelCart,
    seatTotal,
    airTotal,
    airTotalCloud,
    railTotal,
    hotelTotal,
    carTotal,
    changeResTrip
  ) => {
    let newTotalAirAmount = airTotal ? airTotal : airTotalCloud || 0;

    if (
      travelCart &&
      travelCart.RepricedAirCost &&
      travelCart.RepricedAirCost.TotalCost &&
      !changeResTrip
    ) {
      newTotalAirAmount = travelCart.RepricedAirCost.TotalCost;
    }
    return newTotalAirAmount + seatTotal + hotelTotal + carTotal + railTotal;
  }
);
